// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:57:50

export default {
  "id": "dice-fusion",
  "slug": "dice-fusion",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/80da184b1371492795babd5433354483-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/80da184b1371492795babd5433354483/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Dice Fusion",
      "description": "Dice Fusion is a casual game with puzzle content. The game is easy to understand and use the game mechanism, as well as highly strategic gameplay, colorful vision and with a leisurely background sound, to bring users visual and auditory dual enjoyment, so as to achieve the relaxation of the user's physical and mental needs.",
      "instructions": "Drag the mouse dice to merge, and complete the goal of each level to get a reward",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "1player",
        "2048",
        "dice",
        "levels",
        "relaxing"
      ]
    },
    "zh-CN": {
      "title": "骰子融合",
      "description": "《骰子融合》是一款带有解谜内容的休闲游戏。游戏易于理解和使用，拥有高度策略性的玩法、丰富的视觉效果以及轻松的背景音乐，为用户提供视觉和听觉的双重享受，从而满足用户身心放松的需求。",
      "instructions": "拖动鼠标骰子进行合并，完成每个关卡的目标以获得奖励",
      "genres": [
        "休闲",
        "解谜"
      ],
      "tags": [
        "1人",
        "2048",
        "骰子",
        "关卡",
        "放松"
      ]
    },
    "zh-TW": {
      "title": "骰子融合",
      "description": "骰子融合是一款具有益智內容的休閒遊戲。遊戲簡單易懂，遊戲機制使用便捷，並具備高策略性的遊戲玩法、豐富的色彩視覺及輕鬆的背景音樂，為用戶帶來視聽雙重享受，以達到用戶身心的放鬆。",
      "instructions": "將滑鼠擲骰子拖動以合併，並完成每關的目標以獲得獎勵",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "1玩家",
        "2048",
        "骰子",
        "等級",
        "放鬆"
      ]
    },
    "zh-HK": {
      "title": "骰子融合",
      "description": "骰子融合是一款充滿謎題內容的休闲遊戲。遊戲操作簡單易懂，結合高策略性的遊戲玩法、豐富的色彩視覺以及悠閒的背景音樂，帶給用戶視覺與聽覺的双重享受，從而滿足用戶身心的放鬆需求。",
      "instructions": "將滑鼠骰子拖移合併，完成每關目標以獲得獎勵",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "1人遊戲",
        "2048",
        "骰子",
        "等級",
        "輕鬆"
      ]
    },
    "ja": {
      "title": "サイコロ融合",
      "description": "ダイス・フュージョンはパズルコンテンツを持つカジュアルゲームです。ゲームは理解しやすく、ゲームメカニズムを簡単に使い、戦略的なゲームプレイ、カラフルな視覚とリラックスした背景音楽を提供することで、ユーザーに視覚と聴覚の両方の楽しみを提供し、ユーザーの物理的・精神的なリラクゼーションを達成します。",
      "instructions": "マウスのダイスをドラッグして合体させ、各レベルの目標を達成して報酬をゲットしてください。",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "1プレイヤー",
        "2048",
        "サイコロ",
        "レベル",
        "リラックス"
      ]
    },
    "ko": {
      "title": "디스 레플릭션 (Dice Fusion)",
      "description": "딩크 펄션은 패ズル 콘텐츠를 포함한 캐주얼 게임입니다. 게임은 이해하기 쉽고, 게임 메커니즘을 활용하며, 높은 전략적인 게임 플레이, 다채로운 시각적 요소와 편안한 배경 음악으로 사용자에게 시각적 및 청각적 양면의 즐거움을 제공하여 사용자의 신체적 및 심리적 필요를 풀어줍니다.",
      "instructions": "마우스로 주사위를 드래그하여 합치고, 각 레벨의 목표를 달성하여 보상을 받으세요.",
      "genres": [
        "캐주얼",
        "퍼즐"
      ],
      "tags": [
        "1플레이어",
        "2048",
        "주사위",
        "레벨",
        "편안한"
      ]
    },
    "fr": {
      "title": "Mélange de Dés",
      "description": "Dice Fusion est un jeu casual avec du contenu de puzzle. Le jeu est facile à comprendre et à utiliser le mécanisme de jeu, ainsi qu'un gameplay hautement stratégique, une vision colorée et un fond sonore apaisant, pour offrir aux utilisateurs un double plaisir visuel et auditif, afin de répondre aux besoins de relaxation physique et mentale de l'utilisateur.",
      "instructions": "Faites glisser le dé de la souris pour fusionner, et accomplissez l'objectif de chaque niveau pour obtenir une récompense.",
      "genres": [
        "Facile",
        "Puzzle"
      ],
      "tags": [
        "1 joueur",
        "2048",
        "dés",
        "niveaux",
        "apaisant"
      ]
    }
  }
};
